import { I as t } from "../../iconLoader.gen-sImvjIkd.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
//# sourceMappingURL=typeGuards.js.map
